/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.controller('CtasCtrl', ['$scope', 'State', 'CONFIG', function ($scope, State, CONFIG) {

        var app = CONFIG.app;
        var loc = CONFIG.app.locale;
        var ctas = {};

        function init(mode, item) {
            ctas.mode = mode;
            ctas.item = item || app.item;
            if (ctas.item) {
                if (ctas.item.tags) {
                    angular.forEach(ctas.item.tags, function (tag) {
                        if (tag.category === 3) {
                            ctas.poi = tag;
                        }
                    })
                } else {
                    ctas.poi = ctas.item.poi;
                }
            } else {
                ctas.item = {
                    id: app.id,
                    url: app.url,
                    media: app.media,
                };
            }
        }

        function getMedia() {
            var media = null;
            if (ctas.item) {
                if (ctas.item.media) {
                    media = ctas.item.media;
                } else if (ctas.item.photos && ctas.item.photos.length) {
                    media = ctas.item.photos[0] + '?width=1200&height=630&mode=crop';
                }
            }
            return media;
        }

        ctas.getMedia = getMedia;

        $scope.loc = loc;
        $scope.ctas = ctas;
        $scope.init = init;
        
    }]);

}());